import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-subscription-reminder-popup',
  templateUrl: './subscription-reminder-popup.component.html',
  styleUrls: ['./subscription-reminder-popup.component.scss'],
  standalone: false
})
export class SubscriptionReminderPopupComponent {
  title = '';
  htmlContent = '';
  constructor(public dialogRef: MatDialogRef<SubscriptionReminderPopupComponent>) { }

  closeDialog() {
    this.dialogRef.close();
  }
}
